module.exports = __webpack_public_path__ + "img/NextGenWebInterfaceMK3.61f114bd.png";